import React from "react";
import { createPortal } from "react-dom";
import { X, Youtube } from "lucide-react";

export function getYouTubeId(url) {
  if (!url) return null;
  const direct = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/
  );
  if (direct) return direct[1];
  const param = url.match(/[?&]v=([\w-]{11})/);
  return param ? param[1] : null;
}

export default function VideoModal({ url, title, onClose }) {
  const id = getYouTubeId(url);
  return createPortal(
    <div
      data-testid="video-modal"
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(10,31,68,0.88)" }}
      onClick={onClose}
    >
      <div className="w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2 text-white min-w-0">
            <Youtube size={20} style={{ color: "#F97316" }} />
            <span className="font-heading font-semibold truncate">{title || "Video"}</span>
          </div>
          <button
            data-testid="video-modal-close"
            onClick={onClose}
            className="text-white rounded-lg p-2 transition-colors hover:bg-white/10"
          >
            <X size={22} />
          </button>
        </div>
        {id ? (
          <div className="relative w-full rounded-xl overflow-hidden bg-black" style={{ paddingBottom: "56.25%" }}>
            <iframe
              data-testid="video-iframe"
              className="absolute inset-0 w-full h-full"
              src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
              title={title || "Video"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <div className="rounded-xl bg-white p-8 text-center text-[#6B7280]">
            Unable to embed this video.{" "}
            <a href={url} target="_blank" rel="noopener noreferrer" className="text-[#F97316] underline">
              Open link
            </a>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
